// Collection Read More
document.addEventListener("DOMContentLoaded",()=>{
  const c=document.querySelector(".custom_description .metafield-rich_text_field");
  if(!c)return;
  const p=c.querySelectorAll("p");
  if(p.length<2)return;
  let open=0;
  const h=()=>{
    const r1=c.getBoundingClientRect();
    const r2=p[0].getBoundingClientRect();
    return r2.bottom-r1.top;
  };
  c.style.overflow="hidden";
  c.style.transition="height .4s cubic-bezier(.4,0,.2,1)";
  requestAnimationFrame(()=>c.style.height=h()+"px");
  const b=c.parentNode.querySelector(".readmore-toggle")||document.createElement("button");
  if(!b.classList.contains("readmore-toggle")){
    b.className="readmore-toggle";
    b.textContent="Read more";
    c.after(b);
  }
  b.onclick=()=>{
    open=!open;
    c.style.height=open?c.scrollHeight+"px":h()+"px";
    b.textContent=open?"Read less":"Read more";
    if(!open)c.scrollIntoView({behavior:"smooth",block:"nearest"});
  };
});

// Inline CSS Remove
document.addEventListener("DOMContentLoaded", function(){
  const observer = new MutationObserver(function(){
    const btn = document.querySelector('.product__info-wrapper .nm-portal .product-form__submit');
    if(btn && btn.hasAttribute("style")){
      btn.removeAttribute("style");
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// Product Custom Content
document.addEventListener("DOMContentLoaded", function(){
 const container = document.querySelector('.product-custom-content .metafield-rich_text_field');
  if(!container) return;
  const elements = Array.from(container.children);
  let currentWrapper = null;
  elements.forEach(function(el){
    if(el.tagName.toLowerCase() === 'h3'){
      currentWrapper = document.createElement('div');
      currentWrapper.className = 'content_item';
      container.insertBefore(currentWrapper, el);
      currentWrapper.appendChild(el);
    }
    else if(currentWrapper){
      currentWrapper.appendChild(el);
    }
  });
});

// Custom Review Slider
document.addEventListener("DOMContentLoaded", function(){
 const container = document.querySelector('.product-custom-reviews .metafield-rich_text_field');
  if(!container) return;
  const elements = Array.from(container.children);
  let currentWrapper = null;
  elements.forEach(function(el){
    if(el.tagName.toLowerCase() === 'h4'){
      currentWrapper = document.createElement('div');
      currentWrapper.className = 'review_item';
      container.insertBefore(currentWrapper, el);
      currentWrapper.appendChild(el);
    }
    else if(currentWrapper){
      currentWrapper.appendChild(el);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".product-custom-reviews .metafield-rich_text_field");

  if (!container) return;
  const items = container.querySelectorAll(".review_item");

  if (items.length === 0) return;
  const swiperEl = document.createElement("div");
  swiperEl.classList.add("swiper", "reviews-swiper");

  const wrapper = document.createElement("div");
  wrapper.classList.add("swiper-wrapper");

  items.forEach(item => {
    const slide = document.createElement("div");
    slide.classList.add("swiper-slide");
    slide.appendChild(item);
    wrapper.appendChild(slide);
  });

  swiperEl.appendChild(wrapper);

  swiperEl.insertAdjacentHTML("beforeend", `
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-pagination"></div>
  `);

  container.innerHTML = "";
  container.appendChild(swiperEl);

  new Swiper(".reviews-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 600,
    loop: true,

    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },

    pagination: {
      el: ".reviews-swiper .swiper-pagination",
      clickable: true
    }
  });
});


// Related Products Slider
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".related-products");
  if (!section) return;

  const observer = new MutationObserver(initSwiper);
  observer.observe(section, { childList: true, subtree: true });

  function initSwiper() {
    const grid = section.querySelector(".product-grid");
    if (!grid || grid.classList.contains("swiper-ready")) return;

    const items = grid.querySelectorAll("li");
    if (!items.length) return;

    grid.classList.add("swiper-ready");
    observer.disconnect();

    const swiper = document.createElement("div");
    swiper.className = "swiper related-swiper";

    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    items.forEach(item => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(item);
      wrapper.appendChild(slide);
    });

    swiper.appendChild(wrapper);
    swiper.insertAdjacentHTML("beforeend", '<div class="swiper-scrollbar"></div>');

    grid.innerHTML = "";
    grid.appendChild(swiper);

    new Swiper(swiper, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      speed: 8000,

      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
      },
      freeMode: {
        enabled: true,
        momentum: false
      },
      scrollbar: {
        el: swiper.querySelector(".swiper-scrollbar"),
        draggable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 3
        }
      }
    });
  }
});


// Header Menu
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".header__inline-menu details");
  items.forEach(item => {
    item.addEventListener("mouseenter", function () {
      item.setAttribute("open", "");
    });
    item.addEventListener("mouseleave", function () {
      item.removeAttribute("open");
    });
  });
});


// Post Inline CSS
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".template-article p, .template-article div:has(img), .template-article img")
    .forEach(function(p){
      p.removeAttribute("style");
    });
});


// White Space Numbers
document.querySelectorAll(`
.contact-faq li a,
.product-tab .tab-content a,
.visit_plan p a,
.page-default p a,
.page-default li a,
.shopify-policy__container p a,
.shopify-policy__container li a
`).forEach(link => {

  if (link.href.startsWith("tel:")) {
    link.style.whiteSpace = "nowrap";
  }

});

// Phone Number
document.addEventListener("input", function(e){
  if(e.target.id === "ContactForm-phone"){
    e.target.value = e.target.value.replace(/\D/g,'');
  }
});